module.exports = __webpack_public_path__ + "sr.svg?f67016269c4ca77249ae6142f99cc626";